import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationDE from '../translationDE.json';
import translationEN from '../translationEN.json';

/**
 * TODO!
 */
// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)

// we could add a base translation before backend is loaded. Probably menu names and login stuff?
const resources = {
  en: {
    translation: translationEN,
  },
  de: {
    translation: translationDE,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'de', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
      prefix: '{',
      suffix: '}',
    },
  });

export default i18n;
